<!--  -->
<template>
    <div>
        <!-- 通过作用域插槽将数据丢给父组件 -->
        <div v-if="parkingLotList.length > 0" class="parkings-search-result">
            <div class="parkings-result-item flex" v-for="(item, index) in parkingLotList" :key="index">
                <div class="result-item-left flex-column justify-between">
                    <p class="result-item-name">{{ item.parkName }}</p>
                    <p class="result-item-number">
                        车位数量：<span :class="['result-item-number-restStall', item.restStall == 0 ? 'result-item-number0' : item.restStall >= 20 && item.restStall < 40 ? 'result-item-number20' : 'result-item-number40']">{{ item.restStall }}</span
                        ><span class="result-item-number-total">/{{ item.totalStall }}</span>
                    </p>
                </div>
                <div @click="toParking(item)" class="result-item-right flex-column justify-center align-center">
                    <img src="@/assets/images/parking/sitelogo.png" alt="" />
                    <p>{{ item.distance }}km</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ParkingList",
    props: {
        parkingLotList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {};
    },
    mounted() {},

    methods: {
        // 挑转到停车
        toParking(item) {
            item.type = "parking";
            this.$router.push({ name: "Parking", params: item });
        },
    },
};
</script>
<style lang="less" scoped>
.parkings-search-result {
    // min-height: calc(100vh-205px);

    margin-top: 16px;
    .parkings-result-item {
        width: 750px;
        height: 160px;
        background-color: #fff;
        padding: 36px 23px;
        border-bottom: 1px solid #dbdada;
        .result-item-left {
            height: 100%;
            .result-item-name {
                font-size: 32px;
                color: #333333;
            }
            .result-item-number {
                color: #666666;
                .result-item-number-total {
                    font-size: 32px;
                }
                .result-item-number-restStall {
                    font-size: 40px;
                }
                .result-item-number0 {
                    color: #f72d2d;
                }
                .result-item-number20 {
                    color: #f76a2d;
                }
                .result-item-number40 {
                    color: #41cf8a;
                }
            }
        }
        .result-item-right {
            margin-left: auto;
            color: #666666;
            border-left: 1px solid #009af34d;
            padding-left: 40px;
            img {
                width: 48px;
                height: 48px;
                margin-bottom: 4px;
            }
        }
    }
}
</style>
